import React from 'react';
import { Image } from 'react-bootstrap';
import './Layout.css';

type TextSize = 'large' | 'medium' | 'small';

interface TextProps {
    size: TextSize;
    children: React.ReactNode;
    className?: string;
}

export const Text: React.FC<TextProps> = ({ size, children, className }) => {
    return (
        <div className={`text-${size} ${className || ''}`}>
            {children}
        </div>
    );
};

type LayoutProps = {
    children: React.ReactNode;
    footerContent?: React.ReactNode;
};

const Layout = ({ children, footerContent }: LayoutProps) => {
    return (
        <div className="app-layout">
            <header className="app-header">
                <Image src="ft-logo.svg" alt="logo" />
            </header>
            <main className="app-content">
                {children}
            </main>
            {footerContent && (
                <footer className="app-footer">
                    {footerContent}
                </footer>
            )}
        </div>
    );
};

export { type TextSize };
export default Layout;